import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=51833354&scoped=true&"
import script from "./EventItem.vue?vue&type=script&lang=ts&"
export * from "./EventItem.vue?vue&type=script&lang=ts&"
import style0 from "./EventItem.vue?vue&type=style&index=0&id=51833354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51833354",
  null
  
)

export default component.exports